import Reveal from 'stimulus-reveal-controller'

export default class extends Reveal {
  static targets = ["button", "item"]

  connect() {
    super.connect()
  }

  showFormHideButton(event) {
    const form = event.currentTarget.closest('form')

    const buttonInThisForm = form.querySelector('[data-reveal-target="button"]')
    buttonInThisForm.classList.add("hidden")

    const itemsInThisForm = form.querySelectorAll('[data-reveal-target="item"]')
    itemsInThisForm.forEach(item => {
      item.classList.remove("hidden")
    })
  }
}
